// 风险处理相关请求
import req from './index'


//风险处理-分配节点处理人员
export const AllocationUser = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RiskDisposeAssignUser_Set', params)
}

//获取常规风险列表
export const GetGeneralRisks = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.RiskDisposeList_Get', params)
}

//风险处理图片列表
export const GetRiskDisposePic = (params) => {
  // return req.post('api/admin.php?s=Admin.Airport.RiskDisposePicList_Get', params)
  return req.post('api/admin.php?s=Admin.Airport.RiskDisposePic_Get', params)
}

//风险处理-详情
export const GetRiskImgInfo = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RiskDisposeInfo_Get', params)
}
//风险处理-处理填报
export const GetProcessingReporting = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RiskTreatmentSet', params)
}
//风险处理-获取处理人员
export const GetUserInfoFun = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RiskDisposeAssignUser_Get', params)
}
//风险处理-分配处理人员
export const AllocationUserFun = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RiskDisposeAssignUser_Set', params)
}
//风险处理-忽略风险点
export const IgnorePointFun = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RiskDisposeIgnore_Set', params)
}




//获取巡检图像-列表
export const getPatrolImages = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.InsImageList_Get', params)
}

//获取巡检图像-节点数据列表
export const getNodeDataList = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.InsImageList_PointList', params)
}

//获取巡检图像-节点数据列表头部
export const getNodeDataListHead = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.InsImageList_PointListTab', params)
}

//获取巡检图像-节点处理详情信息
export const getNodeDataListInfo = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.InsImageList_PointInfo', params)
}

//获取定点巡检图像-比较图片
export const getCompareImages = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.InsImageList_Compare', params)
}

//将图片放入异常排查
export const putAbnormaltroubleshoot = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.FaultCheckList_Set', params)
}
//对比图片
export const compareImages = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.ConventionList_Compares', params)
}

//获取常规巡检-列表
export const getRoutineInspection = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.New_InsImageList_Get', params)
}

//上传图片
export const submitPictureFun = (params) => {
  return req.file('api/admin.php?s=Admin.Airport.Upload_Pic', params)
}

//上传图片
export const uploadPicExAPI = (params) => {
  return req.file('api/admin.php?s=Admin.Airport.Upload_Pic_ex', params)
}

// 断点续飞
export const goBreakApi = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.GoBreak', params)
}

// 删除巡检记录
export const delRecordApi = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.InsImageList_Del', params)
}

// 上传图片
export const uploadImageFun = (params) => {
  return req.file('api/admin.php?s=Admin.Airport.InsPointRiskDisposePic_Upload', params)
}

// 阶段填报
export const stageFillFun = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.InsPointRisk_Dispose', params)
}



// 获取所有的处理人员
export const getHandlerListFun = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.UserGroup_Get', params)
}